let view = null;

export default {
	namespace: 'single-speaker',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: SpeakerView } = await import(
			/* webpackChunkName: "speaker-view" */ '../../templates/SpeakerView'
		);
		view = new SpeakerView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
